import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-bordered" }
const _hoisted_2 = { class: "d-flex dropdown-menu-card justify-content-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-group m-3",
  style: {"display":"inline-block"}
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary btn-sm",
    type: "submit"
  }, "Go")
], -1)
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("td", null, "ID"),
    /*#__PURE__*/_createElementVNode("td", null, "Offer"),
    /*#__PURE__*/_createElementVNode("td", null, "Payout"),
    /*#__PURE__*/_createElementVNode("td", null, "Click Time"),
    /*#__PURE__*/_createElementVNode("td", null, "Conversion Time"),
    /*#__PURE__*/_createElementVNode("td", null, "Affiliate CID"),
    /*#__PURE__*/_createElementVNode("td", null, "URL"),
    /*#__PURE__*/_createElementVNode("td", null, "Response")
  ])
], -1)
const _hoisted_10 = ["value", "onInput"]
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_export_report = _resolveComponent("button-export-report")!
  const _component_card_toolbar_menu_item = _resolveComponent("card-toolbar-menu-item")!
  const _component_card_toolbar_menu = _resolveComponent("card-toolbar-menu")!
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_next_date_range_picker = _resolveComponent("next-date-range-picker")!
  const _component_offer_selector = _resolveComponent("offer-selector")!
  const _component_entity = _resolveComponent("entity")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_card_toolbar_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_card_toolbar_menu_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_button_export_report, {
                  class: "btn-sm",
                  export_type: "csv",
                  entity_endpoint_name: "/partners/conversions/getList",
                  filename: "conversions_report",
                  noButtonStyling: true,
                  payload: _ctx.getListPayload('csv')
                }, null, 8, ["payload"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_dw_loader, { active: _ctx.busy }, null, 8, ["active"]),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)), ["prevent"])),
          style: {"width":"100%"}
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_next_date_range_picker, {
              modelValue: _ctx.filters.dates,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.dates) = $event)),
              format: 'DD/MM/YYYY HH:mm',
              block_minutes: true,
              onShortcutUpdated: _cache[1] || (_cache[1] = (v) => {_ctx.filters.shortcut_chosen = v})
            }, null, 8, ["modelValue"]),
            _createVNode(_component_offer_selector, {
              modelValue: _ctx.filters.offer_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.offer_id) = $event)),
              style: {"margin-left":"20px"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_6
        ], 32),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(r.id), 1),
                  _createElementVNode("td", null, [
                    (r.offer_id && r.offer_name)
                      ? (_openBlock(), _createBlock(_component_entity, {
                          key: 0,
                          id: r.offer_id,
                          name: r.offer_name,
                          onClickCallback: _ctx.entityClicked,
                          type: 'offer'
                        }, null, 8, ["id", "name", "onClickCallback"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(r.cost), 1),
                  _createElementVNode("td", null, _toDisplayString(r.click_created_at), 1),
                  _createElementVNode("td", null, _toDisplayString(r.created_at), 1),
                  _createElementVNode("td", null, _toDisplayString(r.aff_clickid), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("textarea", {
                      class: "form-control form-control-solid form-control-sm",
                      value: r.url,
                      name: "url",
                      onInput: ($event: any) => (_ctx.handleChange(r, $event))
                    }, null, 40, _hoisted_10)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("textarea", {
                      class: "form-control form-control-solid form-control-sm",
                      value: r.http_response,
                      disabled: ""
                    }, null, 8, _hoisted_11)
                  ])
                ]))
              }), 256))
            ])
          ])
        ]),
        _createVNode(_component_pagination, {
          modelValue: _ctx.pagination,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagination) = $event)),
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadData()))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}